import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  PERFORMING_ASSETS_EYEBROW_SX,
  PERFORMING_ASSETS_HAIRLINE,
} from "./performingAssetsStyles";

const PerformingAssetsSegmentation = ({ fields = [] }) => {
  if (!fields.length) return null;

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
        gridAutoRows: "1fr",
        gap: 1,
        alignItems: "stretch",
      }}
    >
      {fields.map(({ label, value }) => (
        <Box
          key={label}
          sx={{
            minWidth: 0,
            maxWidth: "100%",
            px: 1.5,
            py: 1.25,
            borderRadius: 1.5,
            border: `1px solid ${PERFORMING_ASSETS_HAIRLINE}`,
            bgcolor: "#fafafa",
          }}
        >
          <Typography component="p" sx={PERFORMING_ASSETS_EYEBROW_SX}>
            {label}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              mt: 0.5,
              fontWeight: 500,
              color: "text.primary",
              overflowWrap: "anywhere",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
            title={value}
          >
            {value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default PerformingAssetsSegmentation;
